import logo from 'tmrAssets/images/logo-big.png'
import './aboutModal.scss'
import templateUrl from './aboutModal.html'

/**
 * Configures an About Modal using $mdPanel
 *
 * @type {ngConfig}
 */
function tmrAboutModalConfig($mdPanelProvider) {
  'ngInject'
  $mdPanelProvider.definePreset('aboutModal', {
    templateUrl,
    controller: 'tmrAboutModalController',
    controllerAs: '$ctrl',
    panelClass: 'tmr-modal tmr-about-modal md-whiteframe-1dp',
    clickOutsideToClose: true,
    escapeToClose: true,
  })
}

/**
 * Simplifies the usage of the {@link tmrAboutModalConfig aboutModal panel preset}
 *
 * @example <caption>In a controller</caption>
 * this.TmrAboutModal($event);
 *
 * @alias TmrAboutModal
 * @type {ngFactory}
 */
function TmrAboutModalFactory($mdPanel) {
  'ngInject'

  return () => {
    let position = $mdPanel.newPanelPosition().absolute().center()

    return $mdPanel.open('aboutModal', {
      position,
      hasBackdrop: true,
    })
  }
}

/**
 * Controller for the panel preset aboutModal
 *
 * @type {ngController}
 * @see TmrAboutModal
 */
export class tmrAboutModalController {
  static ngType = 'controller'

  constructor($window, mdPanelRef, TmrApi) {
    'ngInject'
    Object.assign(this, { $window, mdPanelRef, logo, TmrApi })
  }

  $onInit() {
    let year = new Date().getFullYear().toString()
    this.year = year == '2021' ? year : `2021 - ${year}`
    this.version = this.$window.TMR.version
    this.buildDate = new Date(this.$window.TMR.buildDate)
    this.TmrApi.get('Info').then(({ data }) => {
      this.beCoreVersion = data.coreVersion
      this.beCustomizationVersion = data.customizationVersion
    })
  }
}

export { tmrAboutModalConfig as config }
export const factory = ['TmrAboutModal', TmrAboutModalFactory]
